import React, { useEffect, useRef, useState } from 'react'
import PageTitle from '../../pageTitle.component'
import { IArticleHead } from '../../../interfaces/article'
import Marker from './marker.component'
import FeaturedNewsThumbnail from './featuredNewsThumbnail.component'
import LightBackground from '../lightBackground.component'
import useTimer from '../../../hooks/useTimer'
import { useIntersection } from '../../../hooks/useIntersection'

interface IFeaturedNewsPanelProps {
  articles: IArticleHead[]
}

const FeaturedNewsPanel: React.FC<IFeaturedNewsPanelProps> = ({ articles }) => {
  const [activeItemId, setActiveItemId] = useState('')
  const [stopCarousel, setStopCarousel] = useState(false);
  const ref = useRef(null);
  const inViewport = useIntersection(ref, '0px');

  useEffect(() => {
    if (articles.length) {
      setActiveItemId(articles[0].slug)
    }
  }, [articles])

  const handleClick = (id: string): void => {
    setActiveItemId(id)
  }

  useTimer(
    activeItemId,
    articles.map(({ slug }) => slug),
    setActiveItemId,
    stopCarousel
  )

  useEffect(() => {
    const keyDownHandler = (event: any) => {
      if (event.key === " " && inViewport) {
        event.preventDefault();
        setStopCarousel(!stopCarousel);
      }
    };

    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [stopCarousel, inViewport]);

  return (
    <section className='relative pt-16 pb-0 2xl:gap-5.5 mx-page-side-negative-margin' ref={ref}>
      <div className='w-full h-full flex justify-center px-page-side-padding pb-[60px] 2xl:pb-[30px]'>
        <div className='z-1 w-full flex xl:w-8/12 justify-between xl:justify-center flex-col xl:flex-row '>
          <div className='z-1 w-full xl:w-1/4 flex flex-col gap-8 pb-8'>
            <PageTitle title='Kiemelt Hírek' />
            <div className='hidden xl:flex justify-center items-center gap-2 xl:gap-6 xl:justify-start'>
              {articles.map(({ slug }) => (
                <Marker
                  id={slug}
                  activeItemId={activeItemId}
                  handleClick={handleClick}
                  key={slug}
                />
              ))}
            </div>
          </div>
          <div className='z-1 w-full xl:w-3/4 h-full'>
            <div className='relative xl:pb-0 h-full w-full xl:w-2/3'>
              {articles.map((item) => {
                return (
                  <FeaturedNewsThumbnail
                    key={item.slug}
                    articleHead={item}
                    activeItemId={activeItemId}
                  />
                )
              })}
            </div>
          </div>
        </div>
      </div>
      <LightBackground />
    </section>
  )
}

export default FeaturedNewsPanel
